import gql from 'graphql-tag';
import { FeatureFlagsQueryRaw } from './FeatureFlagsQueryRaw';

export const FeatureFlagsQuery = gql`
	${FeatureFlagsQueryRaw}
`;
